(function(){
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  const wraps = document.querySelectorAll('[data-about-slideshow]');
  wraps.forEach(function(wrap){
    const slides = wrap.querySelectorAll('.about-slide');
    const dots = wrap.querySelectorAll('.about-slideshow-dot');
    if (slides.length < 2) return;
    const interval = parseInt(wrap.dataset.interval, 10) || 3500;
    let i = 0;
    let timer = null;
    function setActive(n){
      slides.forEach(function(s,idx){ s.classList.toggle('is-active', idx === n); });
      dots.forEach(function(d,idx){ d.classList.toggle('is-active', idx === n); });
    }
    function next(){ i = (i + 1) % slides.length; setActive(i); }
    function start(){ if (timer) return; timer = setInterval(next, interval); }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    const io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) start(); else stop();
      });
    }, { threshold: 0.35 });
    io.observe(wrap);
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) stop();
  });
})();
